/**
 * Generated by "@vuepress/internal-layout-components"
 */
export default {
  "NotFound": () => import("/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/theme-default/layouts/404.vue"),
  "Layout": () => import("/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/theme-default/layouts/Layout.vue") 
}